import Fireworks from "@fireworks-js/react";
import React from "react";
import FireworksCanvas from "../../../../components/FireworkComponent";
import './index.css'
import { motion } from "framer-motion";
import Confetti from 'react-confetti'


const WelcomeView = ({teamInfo})=>{
    return(<div>
        <Confetti colors={["#FFD700", "#000000ff", "#8e8989ff"]}/>
        <FireworksCanvas setup={{
            particles: 200,
            explosion: 10,
            intensity:20
        }} />
        <motion.div 
         animate={{
    filter: [
      "drop-shadow(0 0 0px gold)",
      "drop-shadow(0 0 25px gold)",
      "drop-shadow(0 0 0px golf)",
    ],
     opacity: [1, 0.85, 1],
    scale: [1, 1.03, 1]
  }}
  transition={{ duration: 2, repeat: Infinity }} 
        className="welcome-view-header-title">
            <p>BIENVENIDO</p>
            <p>{teamInfo?.name}</p>
        </motion.div>
        <motion.div 
                 animate={{
     opacity: [1, 0.85, 1],
    scale: [1, 1.2, 1]
  }}
  transition={{ duration: 2, repeat: Infinity }} 
        className="welcome-view-img-team-card">
            <img width={200} height={200} src={teamInfo?.pictureTeam} />
        </motion.div>
        <motion.div 
        animate={{
     opacity: [1, 0.85, 1],
    scale: [1, 1.03, 1],

  }}
      transition={{ duration: 2, repeat: Infinity }} 

        className="welcome-view-tournament-card">
            <img width={80} height={80} src={teamInfo?.torneo?.imgPicture}/>
            <p>{teamInfo?.torneo?.name}</p>

        </motion.div>

    </div>)
}

export default WelcomeView